// client/src/utils/apifetch.js

// ✅ Base API URL comes from environment
const API_BASE = import.meta.env.VITE_API_URL || "";

export async function apiFetch(
  path,
  options = {},
  logout,
  navigate
) {

  const token = localStorage.getItem("token");

  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };

  // ❗ Only add JSON header if body is NOT FormData
  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  // ✅ Always prepend API_BASE to path
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    credentials: "include"
  });

  if (response.status === 401) {

    localStorage.removeItem("token");
    localStorage.removeItem("uid");
    localStorage.removeItem("usertype");

    localStorage.setItem(
      "logout_reason",
      "Due to maintenance or duplicate login, you have been logged out automatically."
    );

    logout?.(false);
    navigate?.("/login", { replace: true });

    throw new Error("Session expired");
  }

  if (response.status === 403) {
    throw new Error("Access denied");
  }

  return response;
}